import React, { useEffect, useState } from "react";
import { useGame } from "../context/GameContext";

export default function LevelUpAnimation() {
  const { levelUp } = useGame();
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (levelUp) {
      const p = Array.from({ length: 30 }, (_, i) => ({
        id: i,
        angle: (i / 30) * 360,
        distance: 100 + Math.random() * 200,
        size: 4 + Math.random() * 8,
        color: ["#00ff88", "#ffd700", "#00e5ff", "#ff4081", "#b388ff"][Math.floor(Math.random() * 5)],
        duration: 1.5 + Math.random() * 1.5,
      }));
      setParticles(p);
    } else {
      setParticles([]);
    }
  }, [levelUp]);

  if (!levelUp) return null;

  return (
    <div className="levelup-overlay">
      <div className="levelup-particles">
        {particles.map(p => (
          <div
            key={p.id}
            className="levelup-particle"
            style={{
              "--angle": `${p.angle}deg`,
              "--distance": `${p.distance}px`,
              "--duration": `${p.duration}s`,
              "--size": `${p.size}px`,
              "--color": p.color,
            }}
          />
        ))}
      </div>
      <div className="levelup-content">
        <div className="levelup-flash" />
        <div className="levelup-text">
          <span className="levelup-label">LEVEL UP!</span>
          <span className="levelup-number">{levelUp}</span>
          <span className="levelup-subtitle">YOU ARE NOW LEVEL {levelUp}</span>
        </div>
        <div className="levelup-rings">
          <div className="levelup-ring ring-1" />
          <div className="levelup-ring ring-2" />
          <div className="levelup-ring ring-3" />
        </div>
      </div>
    </div>
  );
}
